import { createSelector } from "reselect";
import type { List } from "immutable";
import type { State as EditAccountState } from "../../pages/AppStoreWrapper";
import type { User } from "../../pages/EditAccount";
import type { DefaultState } from "../../reducers/accountInfo/reducer";

export const getGeneralInfo = createSelector(
  (state: EditAccountState) => state.account.accountInfo,
  (accountInfo): DefaultState => accountInfo.toObject()
);

export const getUsers = createSelector(
  (state: EditAccountState) => state.account.accountUsers.get("users"),
  (users: List<User>): Array<User> => users.toArray()
);
